import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Policies stats DTO
 */
@CaslSubject(AppSubjectEnum.POLICY)
export class PoliciesStatsDto extends BaseStatsDto {
	active!: number;
	inactive!: number;
}
